import { CompanyClientDataType } from '@upright/common/model/company-client-data/types';
import { fetchOrThrow, fetchOrThrowNoReturnData } from '../../common/fetchers/fetch-or-throw';

export async function postCompanyClientDataReaction(companyId: string, dataType: CompanyClientDataType, id: number) {
  return await fetchOrThrowNoReturnData(`/company-client-data/${companyId}/${dataType}/${id}/reaction`, 'POST');
}

export async function deleteCompanyClientDataReaction(companyId: string, dataType: CompanyClientDataType, id: number) {
  return await fetchOrThrowNoReturnData(`/company-client-data/${companyId}/${dataType}/${id}/reaction`, 'DELETE');
}

export async function postCompanyClientDataRequest(companyId: string) {
  return await fetchOrThrow<number>(`/company-client-data-request/${companyId}`, 'POST');
}

export async function deleteCompanyClientDataRequest(companyId: string) {
  return await fetchOrThrow<number>(`/company-client-data-request/${companyId}`, 'DELETE');
}
